import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import Controls from "../controls/Controls";
import { createTheme } from "@mui/material";

export default function ConfirmDialog(props) {
  const { confirmDialog, setConfirmDialog, close } = props;
const theme = createTheme();

  return (
    <Dialog
      open={confirmDialog.isOpen}
      sx={{
        "& .MuiDialog-paper": {
          padding: (theme) => theme.spacing(2),
          position: "absolute",
          top: (theme) => theme.spacing(5),
        },
      }}
    >
      <DialogContent
        sx={{
          textAlign: "center",
        }}
      >
        <Typography variant="h6">{confirmDialog.title}</Typography>
        <Typography variant="subtitle2">{confirmDialog.subTitle}</Typography>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: "center",
        }}
      >
        <Controls.Button
          text="No"
          color="default"
          onClick={() => {
            setConfirmDialog({ ...confirmDialog, isOpen: false });
            if (confirmDialog.onCancel) {
              confirmDialog.onCancel();
            }
          }}
        />
        <Controls.Button
          text="Yes"
          variant="contained"
          color="secondary"
          onClick={confirmDialog.onConfirm}
        />
      </DialogActions>
    </Dialog>
  );
}